export const FIELD_NAME = 'question';

export const RESTRICTED_SYMBOLS = ['/', '%'];

export const PATTERN = new RegExp(`^[^${RESTRICTED_SYMBOLS.join('')}]+$`);

export const MAX_LENGTH = 100;
